import { CompType } from '@aloft/toolkit-shared';
// eslint-disable-next-line aloft/no-sui-chakra
import { Badge } from '@aloft/toolkit-sui/chakra';

type CompTypeBadgeProps = {
  compType: CompType;
};

export const CompTypeBadge = ({ compType }: CompTypeBadgeProps) => (
  <Badge backgroundColor={compType} size="sm" textColor={`${compType}Text`} borderRadius="4px">
    {compType}
  </Badge>
);
